import {NOTIFICATION_TYPE_ERROR} from "@/vue/store/modules/notifications";

/**
 * @ngdoc Controller
 * @name RegistrationController
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('RegistrationController', RegistrationController);

    /**
     * @constructor
     * @ngInject
     */
    function RegistrationController(
        $stateParams,
        $scope,
        RegistrationService,
        vcRecaptchaService,
        vrmConfig,
        vrmNotificationsService,
        locale
    ) {
        // Hook up model
        $scope.registrationModel = RegistrationService.registrationModel;

        if ($stateParams.invite)
        {
            $scope.registrationModel.invite_key = $stateParams.invite;
            $scope.registrationModel.invite_type = $stateParams.type || 'site';
        }

        // Get language of the form
        $scope.registrationModel.language = locale.getLocale();

        // Disable by override ReCaptcha when debug mode is enabled
        $scope.captcha_enabled = !vrmConfig.debug;

        // show message on completing request
        $scope.registrationComplete = false;

        $scope.onRecaptchaExpire = function() {
            $scope.registrationModel.recaptcha_response = null;
        }
        $scope.onRecaptchaSuccess = function(response) {
            $scope.registrationModel.recaptcha_response = response;
            // continue registration
            $scope.doRegister();
        }

        let passwordRequirementsNotificationId;

        // Hook up login action
        $scope.doRegister = function() {
            if (!$scope.registrationModel.recaptcha_response && $scope.captcha_enabled) {
                vcRecaptchaService.execute();
                return;
            }

            // Remove password requirements notification if it has been fixed
            if ($scope.registrationForm.password.$valid) {
                vrmNotificationsService.remove(passwordRequirementsNotificationId);
            }

            // Did Form pass frontend validations?
            if ($scope.registrationForm.$valid) {
                RegistrationService
                    .register()
                    .then(function(success) {
                        if (success) {
                            $scope.registrationComplete = true;
                        }
                    }).finally(function() {
                        // Invalidate captcha after each request because it can only be validated once
                        if ($scope.captcha_enabled) {
                            $scope.registrationModel.recaptcha_response = null;
                            vcRecaptchaService.reload();
                        }
                    });
            } else if (!$scope.registrationForm.password.$valid) {
                // Show the password requirements
                passwordRequirementsNotificationId = vrmNotificationsService.add({
                    type: NOTIFICATION_TYPE_ERROR,
                    title: locale.getString('general.password_requirements'),
                    message: `<ul>${locale.getString('general.password_consists')}` +
                        `<li>${locale.getString('general.password_requirement_minimum')}</li>` +
                        `<li>${locale.getString('general.password_requirement_alphanumeric')}</li>` +
                        `<li>${locale.getString('general.password_requirement_special_character')}</li>` +
                        `<li>${locale.getString('general.password_requirement_email')}</li>` +
                        `<li>${locale.getString('general.password_requirement_name')}</li></ul>`,
                    lifespan: 0, // Don't expire, give user time to change their password
                });
            }
        };
    }
})();
